<template>

  <div id="bg">
  <div id="wrapper">

    <!-- Nav and Login Button -->
    <LandingHeader />

    <!-- Pricing Plans -->
    <center>
    <div class="heading">
      <h1>Get Started For <span><i>Free</i></span></h1>
    </div>
    </center>

    <div class="plan-container">

      <div class="plan free">
        <h1 class="name">Free</h1>
        <h2 class="price">$0 <span>/ month</span></h2>
        <ul>
          <li><span>$2.00</span> of free survey credits</li>
        </ul>
        <button @click="goToSignUp">Get Started for Free 🎉</button>
      </div>

      <div class="plan start">
        <h1 class="name">Enterprise</h1>
        <p class="icon">🏢</p>
        <h2 class="price">Flexible Plans<span></span></h2>
        <ul>
          <li><span>1k-50k</span> survey credits</li>
          <li><span>Unlimited</span> team members</li>
          <li>Export data</li>
          <li>Dedicated support</li>
          <li>Push surveys through WhatsApp</li>
        </ul>
        <button @click="contactMe">Set up Demo 👋</button>
      </div>

    </div>


    <!-- Pricing FAQ -->
    <center>
    <div class="heading">
      <h1>Pricing FAQ</h1>
    </div>
    </center>
    <div class="faq-container">

      <div class="item">
        <h3>What is your pricing model?</h3>
        <p>We break down our pricing by each individual answer so you pay for exactly what you get, not a penny more. Our pricing is based on answers types (video, audio, image, multi-choice, text).</p>
      </div>

      <div class="item">
        <h3>What happens if I exceed my wallet balance?</h3>
        <p>Don’t worry, we won’t charge you automatically. Instead, your respondents will simply see a message that the survey is full.</p>
      </div>

      <div class="item">
        <h3>Do you provide a panel?</h3>
        <p>Not at the moment. When you create a survey you get a unique link that you can distribute to your own audience or customers however you’d like.</p>
      </div>

    </div>

  </div>


  <!-- Landing Footer -->
  <LandingFooter />

  </div>


</template>

<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';

export default {

  name: 'pricing',

  props: {},

  components: {
    LandingHeader,
    LandingFooter
  },

  data: function () {
    return {}
  },

  computed: {},

  methods: {

    contactMe() {
      analytics.track('Demo Button Clicked', { page: 'pricing' });
      Calendly.initPopupWidget({url: 'https://calendly.com/outside-voice/intro'})
      return false;
    },

    goToSignUp() {
      analytics.track('Try it Free Button Clicked', { page: 'pricing' });
      this.$router.replace('/signup');
    }

  },

  created() {
    analytics.page('Pricing');
  }

}
</script>


<style lang="scss" scoped>

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}

#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  padding-top: 100px;
  margin: 0 auto;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}

.heading{
  margin-top: 80px;
  h1{
    color: white;
    font-size: 30px;
    font-weight: 600;
    span{
      font-weight: 700;
    }
  }
}

// Pricing Plans
.plan-container{
  justify-content: center;
  align-items: stretch;
  display: flex;
  margin-top: 40px;
}

.plan{
  width: 31%;
  background-color: #0A212D;
  //border: 1px solid rgb(220,220,220);
  border: none;
  border-radius: 20px;
  padding: 20px 25px;
  margin-right: 25px;
  margin-left: 25px;
  position: relative;
  .name{
    font-size: 23px;
    font-weight: 600;
  }
  .icon{
    position: absolute;
      top: 20px;
      right: 20px;
    font-size: 25px;
    color: black;
  }
  .price{
    color: white;
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 20px;
    span{
      color: rgb(180,180,180);
      font-size: 16px;
      font-weight: 500;
    }
  }
  ul{
    list-style: none;
    padding-left: 0px;
    height: 175px;
    li{
      font-size: 14px;
      font-weight: 500;
      color: white;
      height: 36px;
      padding-left: 25px;
      background-repeat: no-repeat;
      background-position: 0px 2px;
      background-size: 15px;
      span{
        font-weight: 700;
      }
    }
  }
  button{
    display: block;
    margin: 0 auto;
    margin-top: 30px;
    color: white;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 10px;
    width: 100%;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
  }
  &.free{
    //border-color: #17D189;
    border-width: 3px;
    .name{
      color: #17D189;
    }
    li{
      background-image: url("../assets/icons/plans-checkmark-green.svg");
    }
    p{
      color: rgb(180,180,180);
      font-size: 14px;
      font-weight: 500;
      margin-top: 38px;
      margin-bottom: 0px;
      text-align: center;
    }
    button{
      color: #003122;
      background-color: #26E2A9;
      border: 1.5px solid #3BF5BD;
      &:hover{
        background-color: #00FFC1;
      }
    }
  }
  &.start{
    //border: 3px solid #1074DF;
    .name{
      color: #00B3FF;
    }
    li{
      background-image: url("../assets/icons/plans-checkmark-blue.svg");
      &.arrow{
        background-image: url("../assets/icons/plans-arrow-blue.svg");
      }
    }
    button{
      background-color: #009DFF;
      border: 1.5px solid #0E78BA;
      &:hover{
        background-color: #00B3FF;
      }
    }
  }
  &.grow{
    //border: 3px solid #6500FF;
    .name{
      color: #6500FF;
    }
    li{
      background-image: url("../assets/icons/plans-checkmark-purple.svg");
      &.arrow{
        background-image: url("../assets/icons/plans-arrow-purple.svg");
      }
    }
    button{
      background-color: #6500FF;
      border: 1.5px solid #500DB8;
      &:hover{
        background-color: #7820FF;
      }
    }
  }
}

.enterprise-contact{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 20px 25px;
  margin-top: 40px;
  background-color: #0A212D;
  //border: 1px solid rgb(220,220,220);
  border: none;
  border-radius: 20px;
  h1{
    color: white;
  }
  .name{
    font-size: 23px;
    font-weight: 600;
    margin: 0px;
  }
  p.info{
    font-size: 14px;
    font-weight: 500;
    color: white;
    margin: 0;
    span{
      font-weight: 700;
    }
  }
  button{
    width: 205px;
    color: white;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 10px;
    border: 1px solid white;
    border-radius: 6px;
    //background-color: black;
    background-color: transparent;
    cursor: pointer;
    transition: all 0.15s ease;
    &:hover{
      //background-color: rgb(30,30,30);
    }
  }
}


.faq-container{
  width: 100%;
  padding: 50px 40px;
  margin-top: 50px;
  background-color: #0A212D;
  border-radius: 6px;
}

.item{
  width: 42%;
  opacity: 1;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 35px;
  margin-right: 50px;
  h3, p{
    color: white;
  }
  h3{
    font-size: 19px;
    line-height: 29px;
    font-weight: 600;
  }
  p{
    font-size: 15px;
    line-height: 25px;
    font-weight: 400;
  }
}



// Mobile Styles
@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
  padding-top: 40px;
}

.heading{
  h1{
    font-size: 25px;
  }
}

.plan-container{
  flex-direction: column;
  .plan{
    width: 100%;
    margin-bottom: 20px;
    h2{
      display: block;
    }
    ul{
      height: auto;
    }
  }
}

.enterprise-contact{
  flex-direction: column;
  height: auto;
  margin-bottom: 50px;
  color: white;
  text-align: center;
  & > *{
    margin-bottom: 10px !important;
  }
  button{
    margin-top: 10px;
  }
}

.faq-container{
  padding: 35px 30px;
  margin-top: 40px;
  margin-bottom: 30px;
}

.item{
  width: 100%;
  h3{
    font-size: 19px;
    line-height: 29px;
  }
  p{
    font-size: 15px;
    line-height: 25px;
  }
}

}

</style>
